import React from 'react';
export var TodaySvg = function () {
    return (React.createElement("svg", { viewBox: "0 0 16 16" },
        React.createElement("polygon", { fill: "#4997C7", points: "14,3 14,0 12,0 12,3 4,3 4,0 2,0 2,3 0,3 0,16 16,16 16,3" }),
        React.createElement("rect", { fill: "#FFFFFF", x: "1", y: "4", width: "14", height: "11" }),
        React.createElement("rect", { fill: "#E8595A", x: "2", y: "5", width: "5", height: "5" })));
};
//# sourceMappingURL=TodaySvg.js.map